/**
 * Vocabulário da tela de sessões de recarga.
 *
 * `notPointedReason` é `varchar` no banco e recebe valores de DUAS origens: o enum
 * `NotPointedReason` do worker do backend (`no_transaction`, `zero_points`, ...) e o desfecho
 * que a sales-api grava quando o parceiro cancela (`canceled`, `failed`). Traduzir os dois
 * aqui é o que evita a tela mostrar dois idiomas na mesma coluna.
 */

export const CHARGE_SESSION_STATUS = {
  pending: 'Aguardando recarga',
  received: 'Processando',
  pointed: 'Pontuado',
  not_pointed: 'Não pontuou',
  expired: 'Expirou',
  canceled: 'Cancelada',
} as const;

export const CHARGE_SESSION_STATUS_CHOICES = Object.entries(CHARGE_SESSION_STATUS)
  .map(([id, name]) => ({ id, name }));

/** Cor do chip por desfecho — verde só para quem realmente pontuou. */
export const CHARGE_SESSION_STATUS_COLOR: Record<string, 'default' | 'success' | 'warning' | 'error' | 'info'> = {
  pending: 'default',
  received: 'info',
  pointed: 'success',
  not_pointed: 'error',
  expired: 'default',
  canceled: 'warning',
};

export const NOT_POINTED_REASON = {
  // Gravados pelo ChargeSessionPointingWorker (backend)
  no_transaction: 'A pontuação não chegou a tempo',
  zero_points: 'A regra do posto resultou em zero pontos',
  customer_blocked: 'Cliente bloqueado ou removido',
  no_place_fuel: 'Posto sem pontos por kWh configurados',
  // Gravados pela sales-api quando o parceiro informa o desfecho
  canceled: 'Recarga cancelada pelo parceiro',
  failed: 'Recarga falhou no parceiro',
} as const;

export function translateStatus(status?: string | null): string {
  if (!status) { return '—'; }
  return CHARGE_SESSION_STATUS[status] ?? status;
}

export function translateNotPointedReason(reason?: string | null): string {
  if (!reason) { return '—'; }
  return NOT_POINTED_REASON[reason] ?? reason;
}
